<template>
    <main class="max-w-5xl m-5 mb-10 w-full p-1">
        <InvoiceForm ref="form" />
        <div>
            <app-button
                v-if="
                    isAdmin &&
                    invoice.versions &&
                    invoice.versions.length > 1 &&
                    invoice.versions[invoice.versions.length - 1].id !== invoice.id
                "
                size="mini"
                icon="icon-trash-can-outline"
                variant="danger"
                @click="removeInvoice()"
                :label="$t('commons.removeThisVersion')"
                class="m-2"
            />
        </div>
        <app-quick-actions :options="quickActions" @choose="$event.run()"></app-quick-actions>
    </main>
</template>

<script>
import { updateBreadCrumbs } from '@/state/state';
import AppQuickActions from '../../components/appQuickActions/AppQuickActions';
import InvoiceForm from './InvoiceForm';
import { getInvoice, removeInvoice } from './invoices.service';
import { confirm } from '@/features/dialogs/dialogs.service';
import { getProject } from '@/features/projects/projects.service';
import AppButton from '@/components/appButton/AppButton.vue';
import { combineLatest } from 'rxjs';

export default {
    components: {
        AppButton,
        InvoiceForm,
        AppQuickActions,
    },

    async created() {
        this.init();
    },
    watch: {
        $route: function () {
            this.init();
        },
    },
    methods: {
        init() {
            this.subscriptions = [
                combineLatest([
                    getProject(this.$route.params.projectId),
                    getInvoice(this.$route.params.projectId, this.$route.params.invoiceId),
                ]).subscribe(([project, invoice]) => {
                    this.project = project;
                    this.invoice = invoice;
                    this.isLastVersion =
                        invoice.versions.findIndex((version) => version.id === this.$route.params.invoiceId) === 0;

                    this.isAdmin = project.me.allowedFeatures.includes('project_invoices');
                    this.isEmitter = project.me.bundleIds.includes(invoice.emitterId);
                    updateBreadCrumbs({
                        invoiceName: invoice.name,
                    });
                }),
            ];
        },
        async removeInvoice() {
            if (await confirm(this.$t('commons.confirmMessage'))) {
                removeInvoice(this.$route.params.projectId, this.$route.params.invoiceId);
                if (this.invoice.versions.length > 1) {
                    this.$router.push({
                        name: this.$route.name,
                        params: {
                            projectId: this.$route.params.projectId,
                            invoiceId: this.invoice.versions[1].id,
                        },
                    });
                } else {
                    this.$router.push({
                        name: this.$route.meta.parentName,
                        params: {
                            projectId: this.$route.params.projectId,
                        },
                    });
                }
            }
        },
    },
    data() {
        return {
            subscriptions: [],
            invoice: { versions: [] },
            project: null,
            isAdmin: false,
            isEmitter: false,
            isLastVersion: false,
        };
    },
    computed: {
        quickActions() {
            if (!this.isAdmin) {
                return [];
            }
            const defaultOptions = [
                {
                    name: this.$t('invoices.newInvoice'),
                    run: () => this.$refs.form.createNew(),
                },
                {
                    name: this.$t('commons.newVersion'),
                    run: () => this.$refs.form.onNewVersion(),
                },
            ];
            if (
                this.invoice.versions &&
                this.invoice.versions.length > 0 &&
                this.invoice.versions[0].id === this.invoice.id
            ) {
                defaultOptions.push({
                    name:
                        this.invoice.versions.length === 1
                            ? this.$t('commons.removeThisGroup')
                            : this.$t('commons.removeThisVersion'),
                    run: async () => {
                        this.removeInvoice();
                    },
                });
            }
            return defaultOptions;
        },
    },
};
</script>
